import { SurveyQuestionResponseStatistics } from '@occc/graphql';
import { buildBarChartTooltipSurveyItems } from './buildBarChartTooltipSurveyItems';
import { BarChartProps } from '../../../../design-system';

export const buildTooltipProps: BarChartProps<
  SurveyQuestionResponseStatistics['sliderResponseRanges'][0]
>['buildTooltipProps'] = ({ payload, rawItem, totalValue }) => {
  const sum = Array.isArray(payload) ? payload[0]?.value ?? 0 : 0;
  const percentage = (sum * 100) / totalValue;
  const range = `${rawItem.rangeStart} - ${rawItem.rangeEnd} range`;

  return {
    items: buildBarChartTooltipSurveyItems({ range, sum, percentage }),
  };
};
